import { Tab, Tabs } from "react-bootstrap";

import BreadCrumb from "../BreadCrumb/BreadCrumb";

import LeaveRequest from "../LeaveRequest/LeaveRequest";
import { RollCallStyle } from "../RollCall/RollCallStyle";
import RollCallListUser from "../RollCallListUser/RollCallListUser";
import RollCall from "../RollCall/RollCall";

const RollCallUser = () => {
  const userInfo = JSON.parse(localStorage.getItem("profile"));
  const userId = userInfo?.users[0]?.IdUser;
  return (
    <>
      {userId === 7250 ? (
        <RollCall />
      ) : (
        <RollCallStyle>
          <BreadCrumb num1="حضور و غیاب" />

          <Tabs
            defaultActiveKey="حضور و غیاب"
            id="uncontrolled-tab-example"
            className="mb-3"
          >
            <Tab eventKey="حضور و غیاب" title="حضور و غیاب">
              <RollCallListUser />
            </Tab>
            <Tab eventKey="درخواست مرخصی" title="درخواست مرخصی">
              <LeaveRequest />
            </Tab>
          </Tabs>
        </RollCallStyle>
      )}
    </>
  );
};

export default RollCallUser;
